import _ from 'lodash';

export const selectAreHeldReasonsLoading = state =>
  _.get(state, ['dashboard', 'heldReasons', 'isLoading'], false);
